<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-middle"
      notFooterPadding
      :contentStyle="{'height': '100%'}"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加产品</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
         >
        <template #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-select-input
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['100px', '150px']"
            ></gj-select-input>
            <gj-category-select
                v-model="filter.categoryId"
            ></gj-category-select>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              name="transferProductAddModal"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :show-overflow="false"
              :offset-height="62"
              adapt-parent
              selection
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
            <template v-slot:sku="{row}">
              <div>
                <gj-text>{{row.productName | defaultShow}}</gj-text>
              </div>
              <div>{{row.sku | defaultShow}}</div>
              <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
            </template>
            <template v-slot:msku="{row}">
              <div>{{row.msku | defaultShow}}</div>
              <div>{{row.fnsku | defaultShow}}</div>
              <div>{{row.asin | defaultShow}}</div>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import {getCanTransferProductPage} from "@/api/warehouse";
  import {ProductEnum} from "@/utils/options";

  export default {
    name: "app-add-product-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      warehouseId: {
        required: true,
      },
      arrivalWarehouseId: {
        required: true,
      },
      arrivalMarketId: {
        required: true,
      },
      hideMskuList: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '200px'},
          {id: 'availableQuantity', header: '现库存可用量', field: 'availableQuantity', minWidth: '80px', align: ''},
        ],
        filter: {
          keyword: {
            key: 'msku',
            value: null
          },
          categoryId: null
        },
        option: {
          keyword: [
            {id: 'msku', text: 'MSKU'},
            {id: 'fnsku', text: 'FNSKU'},
            {id: 'sku', text: 'SKU'},
            {id: 'productName', text: '产品名称'},
            {id: 'asin', text: 'ASIN'},
          ],
        },
        productTypeOption: ProductEnum.typeOption
      }
    },
    created() {
      this.sort.prop = 'sku';
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            warehouseId: this.warehouseId,
            arrivalWarehouseId: this.arrivalWarehouseId,
            arrivalMarketId: this.arrivalMarketId,
            categoryId: this.filter.categoryId,
            hideList: this.hideMskuList,
            [this.filter.keyword.key]: this.filter.keyword.value
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getCanTransferProductPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选产品');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style scoped>
  .add-product-btn {
    margin: 5px 0 10px;
  }
  /deep/ .table{
    flex: 1;
    overflow: auto;
  }
</style>
